import { render, staticRenderFns } from "./Loaders.vue?vue&type=template&id=5e0d49f3&scoped=true&"
import script from "./Loaders.vue?vue&type=script&lang=js&"
export * from "./Loaders.vue?vue&type=script&lang=js&"
import style0 from "./Loaders.vue?vue&type=style&index=0&id=5e0d49f3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e0d49f3",
  null
  
)

export default component.exports